// extracted by mini-css-extract-plugin
module.exports = {"ProfileTag":"ProfileTag_ProfileTag__3Ml9J","LabelWrapper":"ProfileTag_LabelWrapper__9L24B","Value":"ProfileTag_Value__aFCI3","inner":"ProfileTag_inner__8mynX"};